import moment from 'moment'
import { getWidth } from '../components/commonChartFunctions'

export default {
  data() {
    return {
      startDate: '',
      endDate: '',
      currentFilterType: 'whole_year'
    }
  },
  mounted() {
    this.wholeYearRangeClicked()
    this.updateDataAttributes()
  },
  watch: {
    currentFilterType: 'updateDataAttributes'
  },
  computed: {
    chartWidth() {
      return getWidth(this.series[0].data.length)
    }
  },
  methods: {
    sevenDayRangeClicked() {
      this.setDayRange(7, '7_days')
    },
    thirtyDayRangeClicked() {
      this.setDayRange(30, '30_days')
    },
    wholeYearRangeClicked() {
      this.startDate = this.year_info.school_start_date
      this.endDate = moment().endOf('day')
      this.currentFilterType = 'whole_year'
      this.updateChart()
    },
    setDayRange(day, filterType) {
      this.startDate = moment().subtract(day, 'days').startOf('day')
      this.endDate = moment().subtract(1, 'days').endOf('day')
      this.currentFilterType = filterType
      this.updateChart()
    },
    updateDataAttributes() {
      const el = this.$el
      if (!el) return

      el.setAttribute('data-filter-type', this.currentFilterType)
    },
    applyData(data) {
      this.chartData = data
      this.applyDateRangeBounds()
      this.updateChart()
    }
  }
}
